import React, { useState } from 'react';

import { Checkbox, Dialog, DialogContent } from '@material-ui/core';
import { FormControlLabel, IconButton } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import { MdContentCopy } from 'react-icons/md';
import { FiLink } from 'react-icons/fi';

import { DialogTitle, InfoBox, Tooltip } from 'components';
import { parseActions } from 'components/utils';
import { copyToClipboard } from 'utils';
import { BASE_URL } from 'consts';

import styles from './UrlBox.module.scss';

const UrlBox = props => {
  const [open, setOpen] = useState(false);
  const [demo, setDemo] = useState(false);

  const theme = useTheme();

  const renderContent = () => {
    const links = parseActions(props.links, ['manychat', 'anonymous']);
    const highlight = { fontWeight: 'bold', color: theme.palette.primary.main };
    const mode = demo ? '/demo' : '/live';

    const mUrl = URL(props.path, mode, '/fb/psid');
    const aUrl = URL(props.path, mode);

    const copyButton = url => (
      <IconButton color="primary" onClick={() => copyToClipboard(url)}>
        <Tooltip title="Copy to clipboard" placement="top">
          <MdContentCopy />
        </Tooltip>
      </IconButton>
    );

    return (
      <div className={styles.urlBox}>
        {props.demo ? (
          <FormControlLabel
            control={
              <Checkbox
                checked={demo}
                onChange={e => setDemo(e.target.checked)}
                color="primary"
              />
            }
            label="Demo mode"
          />
        ) : null}

        {links.manychat ? (
          <div className={styles.card}>
            <div className={styles.label}>
              <span>ManyChat</span>
              <InfoBox>
                <div className={styles.popup}>
                  <span>Please, replace</span>
                  <span style={highlight}>psid</span>
                  <span>with ManyChat's</span>
                  <span
                    className={styles.textBox}
                    style={{ backgroundColor: highlight.color }}
                  >
                    User Id
                  </span>
                  <span>variable</span>
                </div>
              </InfoBox>
            </div>
            <div className={styles.link}>
              {mUrl.jsx}
              <div>{copyButton(mUrl.raw)}</div>
            </div>
          </div>
        ) : null}

        {links.anonymous ? (
          <div className={styles.card}>
            <div className={styles.label}>
              <span>Anonymous</span>
              <InfoBox>
                <div>This link uses cookies to track users' actions</div>
                <div>
                  In this way, be aware that they can delete or even block cookies
                </div>
              </InfoBox>
            </div>
            <div className={styles.link}>
              {aUrl.jsx}
              <div>{copyButton(aUrl.raw)}</div>
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <>
      <IconButton color="primary" onClick={() => setOpen(true)}>
        <Tooltip title={props.title} placement="top">
          <FiLink />
        </Tooltip>
      </IconButton>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth disableEnforceFocus>
        <DialogTitle onClose={() => setOpen(false)}>{props.title}</DialogTitle>
        <DialogContent>{renderContent()}</DialogContent>
      </Dialog>
    </>
  );
};

const URL = (path, mode, ext) => {
  path = `/${path.replace(/\/+$/, '').replace(/^\/+/, '')}${mode}`;
  ext = ext ? `/${ext.replace(/\/+$/, '').replace(/^\/+/, '')}` : '';

  return {
    raw: `${BASE_URL}${path}${ext}`,
    jsx: (
      <div className={styles.url}>
        <span>{BASE_URL}</span>
        <span>{path}</span>
        <span>{ext}</span>
      </div>
    ),
  };
};

export default UrlBox;
